/* Approval 타입 */
export type ApprovalType = 'ISSUE' | 'DAILY' | 'CLOSURE';

/* Approval 조회 */
export const getApprovalByType = (list: any[] | undefined, type: ApprovalType, order: number) => {
  return list?.find((v) => v.approvalType === type && v.oder === order);
};

/* 날짜 format */
export const formatDate = (dateStr?: string): string => {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

/* 시간 format */
export const formatTime = (dateStr?: string): string => {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
};

/* 요일 */
export const days = [
  { label: 'MONDAY', index: 1 },
  { label: 'TUESDAY', index: 2 },
  { label: 'WEDNESDAY', index: 3 },
  { label: 'THURSDAY', index: 4 },
  { label: 'FRIDAY', index: 5 },
  { label: 'SATURDAY', index: 6 },
  { label: 'SUNDAY', index: 7 }
];

/* 요일 index */
export const getDayIndex = (dateStr?: string) => {
  if (!dateStr) return -1;
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return -1;
  const day = d.getDay();
  return day === 0 ? 6 : day - 1;
};

export const getDayIndexSignDate = (signDate?: string | Date) => {
  if (!signDate) return -1;
  const date = new Date(signDate);
  const day = date.getDay();
  return day;
};

/* 표시 가능 최대 요일 */
export const getMaxDayIndex = (...dates: (string | undefined)[]) =>
  Math.max(...dates.map(getDayIndex));

/* 승인 날짜 render */
export const renderDate = (item?: any): string => {
  //console.log(1212, item)
  return hasSign(item) ? formatDate(item?.signCreateDate) : '';
};

/* 승인 시간 render */
export const renderTime = (item?: any): string => {
  return hasSign(item) ? formatTime(item?.signCreateDate) : '';
};

/* 승인 날짜,시간 render */
export const renderDateTime = (item?: any): string => {
  if (!hasSign(item)) return '';
  return `${formatDate(item?.signCreateDate)} ${formatTime(item?.signCreateDate)}`;
};

/* 승인 날짜,시간 render */
export const renderCustomInfo01 = (item?: any): string => {
  if (!hasSign(item)) return '';
  return `${formatDate(item?.signCreateDate)} ${formatTime(item?.signCreateDate)} ${item?.userNm ?? ''}`;
};


/* 사인 render */
export const renderSign = (item?: any, size: 'normal' | 'large' = 'normal') => {
  if (!hasSign(item)) return '';

  const style =
    size === 'large' ? { maxWidth: 80, maxHeight: 60 } : { maxWidth: 50, maxHeight: 30 };

  if (item.signType === 'DENY') {
    return <span style={style}>DENY</span>;
  }

  return <img src={`data:image/png;base64,${item.sign}`} style={style} />;
};

/* 사인 존재 여부 (DENY 포함) */
export const hasSign = (item?: any): boolean => {
  return !!item?.signType;
};
